import { useEffect } from 'react';
import { MICRO_FEEDBACK_SUBMIT_EVENT } from './index';

/**
 * A hook that allows other components to subscribe to the micro-feedback submit
 * event (via a pubsub channel) and trigger a callback when the event is
 * published.
 */
function useMicroFeedback(handleEvent) {
  useEffect(() => {
    pubsub.subscribe(MICRO_FEEDBACK_SUBMIT_EVENT, handleEvent);
    return () => {
      pubsub.unsubscribe(MICRO_FEEDBACK_SUBMIT_EVENT, handleEvent);
    };
  }, [handleEvent]);
}

export default useMicroFeedback;
